import { IComparator } from "./QueryBuilderUtils";

export const NUMERIC_TYPES = ["numeric", "monetary", "rating-scale", "calculator"];

export const TEXT_TYPES = ["text", "textbox"];

export const DROPDOWN_SELECTION_TYPES = ["single-select", "multi-select"];

export const PEOPLE_SELECTION_TYPES = ["person", "people"];

export const DATE_TYPES = ["date"];

export const GROUP_TYPE = "department";

export const DEFAULT_QUERY_OPTIONS: IComparator[] = [
	{
		value: "eq",
		label: "Equals",
	},
	{
		value: "ne",
		label: "Does not equal",
	},
];

export const REGEX_COMPARATOR_VALUES = ["contains", "startsWith", "endsWith"];

export const NOT_REGEX_COMPARATOR_VALUES = ["notContains", "notStartsWith", "notEndsWith"];

export const TEXT_QUERY_OPTIONS: IComparator[] = [
	{
		value: "eq",
		label: "Equals",
	},
	{
		value: "contains",
		label: "Contains",
	},
	{
		value: "ne",
		label: "Does not Equal",
	},
	{
		value: "notContains",
		label: "Does not Contain",
	},
	{
		value: "startsWith",
		label: "Starts With",
	},
	{
		value: "endsWith",
		label: "Ends With",
	},
	{
		value: "notStartsWith",
		label: "Does not Start With",
	},
	{
		value: "notEndsWith",
		label: "Does not End With",
	},
];

export const NUMERIC_QUERY_OPTIONS: IComparator[] = [
	{
		value: "eq",
		label: "Equals",
	},
	{
		value: "ne",
		label: "Does not equal",
	},
	{
		value: "gt",
		label: "Greater than",
	},
	{
		value: "gte",
		label: "Greater than or equal to",
	},
	{
		value: "lt",
		label: "Less than",
	},
	{
		value: "lte",
		label: "Less than or equal to",
	},
];

export const STATIC_DATE_QUERY_OPTIONS: IComparator[] = [
	{
		value: "lt",
		label: "Before",
	},
	{
		value: "gt",
		label: "After",
	},
];

export const RELATIVE_DATE_QUERY_OPTIONS: IComparator[] = [
	{
		value: "eq",
		label: "Equals",
	},
	{
		value: "lt",
		label: "Greater than",
	},
	{
		value: "lte",
		label: "Greater than or equal to",
	},
	{
		value: "gt",
		label: "Less than",
	},
	{
		value: "gte",
		label: "Less than or equal to",
	},
];

export const ANNIVERSARY_QUERY_OPTIONS: IComparator[] = [
	{
		value: "eq_anniversary",
		label: "On Anniversary Date",
	},
	{
		value: "before_anniversary",
		label: "Before Anniversary Date",
	},
	{
		value: "after_anniversary",
		label: "After Anniversary Date",
	},
];

export const ALLOWED_FIELDS = ["Manager", "Group"];

export const IS_MANAGER_FIELD = {
	_id: "is_manager",
	name: "Has Direct Reports",
	type: "boolean",
	options: [],
	tags: [],
	"visible-to": [],
};
